// Ratkaisut ja mielipiteet (#1180): solutions.v3 — the `solutionsV3` namespace.
// The module's own strings; the screens it copies from v1 keep using `solutionComponents`.

export const solutionsV3Fi = {
  title: "Miten ryhmät suhtautuisivat?",
  lead: "Tekoälyn arvio siitä, miten {{dataset}} -aineiston mielipideryhmät todennäköisesti suhtautuisivat ratkaisuun. Arvio perustuu ryhmän profiiliin ja ratkaisua lähimpiin väittämiin, joiden mitatut luvut näkyvät alla.",
  estimate: "arvio",
  approval: "hyväksyisi",
  confidence: { low: "epävarma", medium: "kohtalainen varmuus", high: "melko varma" },
  keyConcern: "Keskeinen huoli",
  anchors: "Perustuu väittämiin ({{count}})",
  noAnchors: "Mikään väittämä ei osu ratkaisuun: arvio on päätelty ryhmän profiilista.",
  anchorStats: "{{group}} {{agree}} %",
  agreed: "samaa mieltä",
  allAbove: "Kaikki ryhmät todennäköisesti hyväksyisivät ratkaisun.",
  someBelow: "Alle puolet hyväksyisi: {{groups}}.",
  stale: "Ratkaisua on muokattu arvion jälkeen: arvio koskee aiempaa versiota.",
  running: "Arvioidaan ryhmien suhtautumista…",
  notYet: "Ryhmien suhtautumista ei ole vielä arvioitu.",
  run: "Arvioi ryhmien suhtautuminen",
  rerun: "Arvioi uudelleen",
  failed: "Ryhmien suhtautumista ei voitu arvioida: {{message}}",
  loadFailed: "Arvioiden lataus epäonnistui: {{message}}",
};

export const solutionsV3En = {
  title: "How would the groups react?",
  lead: "The AI's estimate of how the opinion groups of {{dataset}} would likely react to the solution. It reasons from each group's profile and the statements nearest the solution, whose measured numbers are shown below.",
  estimate: "estimate",
  approval: "would approve",
  confidence: { low: "uncertain", medium: "moderately confident", high: "fairly confident" },
  keyConcern: "Key concern",
  anchors: "Based on statements ({{count}})",
  noAnchors: "No statement is close to the solution: the estimate is reasoned from the group's profile.",
  anchorStats: "{{group}} {{agree}} %",
  agreed: "agreed",
  allAbove: "Every group would likely approve the solution.",
  someBelow: "Fewer than half would approve: {{groups}}.",
  stale: "The solution was edited after the estimate: it applies to an earlier version.",
  running: "Estimating the groups' reactions…",
  notYet: "The groups' reactions have not been estimated yet.",
  run: "Estimate the groups' reactions",
  rerun: "Estimate again",
  failed: "The groups' reactions could not be estimated: {{message}}",
  loadFailed: "Loading the estimates failed: {{message}}",
};

export const solutionsV3Sv = {
  title: "Hur skulle grupperna reagera?",
  lead: "AI:ns uppskattning av hur opinionsgrupperna i {{dataset}} sannolikt skulle reagera på lösningen. Den utgår från gruppens profil och de påståenden som ligger närmast lösningen, vars uppmätta siffror visas nedan.",
  estimate: "uppskattning",
  approval: "skulle godta",
  confidence: { low: "osäker", medium: "måttligt säker", high: "ganska säker" },
  keyConcern: "Största oro",
  anchors: "Bygger på påståenden ({{count}})",
  noAnchors: "Inget påstående ligger nära lösningen: uppskattningen bygger på gruppens profil.",
  anchorStats: "{{group}} {{agree}} %",
  agreed: "höll med",
  allAbove: "Alla grupper skulle sannolikt godta lösningen.",
  someBelow: "Färre än hälften skulle godta: {{groups}}.",
  stale: "Lösningen har ändrats efter uppskattningen: den gäller en tidigare version.",
  running: "Uppskattar gruppernas reaktioner…",
  notYet: "Gruppernas reaktioner har inte uppskattats ännu.",
  run: "Uppskatta gruppernas reaktioner",
  rerun: "Uppskatta igen",
  failed: "Gruppernas reaktioner kunde inte uppskattas: {{message}}",
  loadFailed: "Uppskattningarna kunde inte laddas: {{message}}",
};
